import React from 'react';
import ReactDOM from 'react-dom/client';
// setup react-router-dom
import { BrowserRouter, Route, Routes, Navigate} from 'react-router-dom'
import HomeTemplate from './templates/HomeTemplate';
import { Provider } from "react-redux";
import { store } from './redux/configStore';
import HomeMobile from './pages/Home/HomeMobile';
import HomeTemplateMobile from './templates/HomeTemplateMobile';
import Login from './pages/Login/Login';
import Demo from './pages/Demo/Demo';
import Home from './pages/Home/Home';
import ResponsiveItem from './HOC/ResponsiveItem/ResponsiveItem';
import 'bootstrap/dist/css/bootstrap.min.css';

// sao cho nay no k nhac lenh khai
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path='' element={<Home />}>
          <Route index element={<Home />}></Route>
          <Route path='home' element={<Home />}></Route>
          {/* <Route index element={<ResponsiveItem Component={Home} ComponentMobile={Home} />}></Route>
          <Route path='home' element={<ResponsiveItem Component={Home} ComponentMobile={Home} />}></Route> */}
          <Route path='login' element={<Login/>}></Route>
          <Route path='demo' element={<Demo/>}></Route>
          <Route path='detail'>
            <Route path=':id'></Route>
          </Route>
          <Route path='*' element={<Navigate to='' />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  </Provider>
);

export const ACCOUNT_ROUTES = {
  LOGIN: "/login"
};

export const DASHBOARD_ROUTES = {
  DASHBOARD: "/",
  HOME: "/home",
  USERS: "/users"
};